import { PatchOperation } from '@app/_store';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AccountActions {
  export class Initialize {
    static readonly type = '[ACCOUNT] Initialize';
    constructor(
      public organizationId?: string,
      public activityId?: string
    ) {}
  }

  // export class Login {
  //   static readonly type = '[ACCOUNT] Login';
  //   constructor(public prompt?: string) {}
  // }

  export class Logout {
    static readonly type = '[ACCOUNT] Logout';
  }

  export class UpdateAccount {
    static readonly type = '[ACCOUNT] Update Account';
    constructor(public operations: PatchOperation[]) {}
  }

  export class ToggleHiddenAdminFeatures {
    static readonly type = '[ACCOUNT] ToggleHiddenAdminFeatures';
  }
}
